@if (billsViewModel) { @if (!billsViewModel?.forbidden) {
<div class="apply-one-grid apply-one-style bg-white">
  <div class="site-width pt-md-3">
    <div class="container-fluid">
      @for (contractItem of billsViewModel?.contracts; track contractItem; let isLast = $last) { @switch
      (contractItem.typeContract) { @case ('activeContract') {
      <ecm-bill-item
        data-e2e="bill-item"
        [viewModel]="contractItem"
        [universe]="billsViewModel?.universe"
        [isVimEligible]="billsViewModel?.isVimEligible"
        [hideBorder]="isLast"
      >
      </ecm-bill-item>
      } @case ('terminatedContract') {
      <ecm-terminated-contract-bill
        data-e2e="bill-multi-item"
        [viewModel]="contractItem"
        [universe]="billsViewModel?.universe"
        [hideBorder]="isLast"
      >
      </ecm-terminated-contract-bill>
      } @case ('protectedHouseContract') {
      <ecm-protected-house-bill
        data-e2e="bill-multi-item"
        [viewModel]="contractItem"
        [universe]="billsViewModel?.universe"
        [hideBorder]="isLast"
      >
      </ecm-protected-house-bill>
      } @case ('multiContract') {
      <ecm-multi-contract-bill
        data-e2e="bill-multi-item"
        [viewModel]="contractItem"
        [universe]="billsViewModel?.universe"
        [hideBorder]="isLast"
      >
      </ecm-multi-contract-bill>
      } } @if (!isLast) {
      <div class="separator mx--1 mx-md-0 mb-md-4"></div>
      } }
    </div>
  </div>
</div>
} @else {
<div class="apply-one-grid apply-one-style">
  <div class="site-width">
    <div class="container-fluid">
      <div class="feedback align-items-center row pt-0 pt-md-1 pb-5">
        <div class="col-12 col-md-4 col-xl-3 px-0 px-md-1">
          <div>
            <div class="alert alert-info">
              <span class="alert-icon icon-info"></span>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-8 col-xl-9">
          <h2 class="h4 text-mw">{{"dashboard.forbidden.noInformation" | translate}}</h2>
        </div>
      </div>
    </div>
  </div>
</div>
} } @else {
<div class="apply-one-grid apply-one-style">
  <div class="site-width">
    <div class="container-fluid">
      <div class="py-5" data-e2e="spinner">
        <ecm-mat-spinner [centered]="true"></ecm-mat-spinner>
      </div>
    </div>
  </div>
</div>
}

<ng-template #forbidden>
  <div class="apply-one-grid apply-one-style">
    <div class="site-width">
      <div class="container-fluid">
        <div class="feedback align-items-center row pt-0 pt-md-1 pb-5">
          <div class="col-12 col-md-4 col-xl-3 px-0 px-md-1">
            <div>
              <div class="alert alert-info">
                <span class="alert-icon icon-info"></span>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-8 col-xl-9">
            <h2 class="h4 text-mw">{{"dashboard.forbidden.noInformation" | translate}}</h2>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #spinner>
  <div class="apply-one-grid apply-one-style">
    <div class="site-width">
      <div class="container-fluid">
        <div class="py-5" data-e2e="spinner">
          <ecm-mat-spinner [centered]="true"></ecm-mat-spinner>
        </div>
      </div>
    </div>
  </div>
</ng-template>
